import { Tooltip } from "@mui/material";
import React from "react";

interface ToolProps {
  text: string;
  children: React.ReactElement<any, any>;
}

export default function StyleTooltip(props: ToolProps) {
  return <Tooltip title={props.text}>{props.children}</Tooltip>;
}
